import InfoSolidSmallIcon from '@cp/src/assets/icons/InfoSolidSmallIcon';
import InitiateMockIcon from '@cp/src/assets/icons/InitiateMockIcon';
import MockAllocatedIcon from '@cp/src/assets/icons/MockAllocatedIcon';
import MockSuccessIcon from '@cp/src/assets/icons/MockSuccessIcon';
import { CheckIcon } from '@navi/web-ui/lib/icons';
import ClockFilledIcon from '@navi/web-ui/lib/icons/ClockIcon';
import { Tag } from '@navi/web-ui/lib/primitives';
import { TagColors } from '@navi/web-ui/lib/primitives/Tag/types';
import React, { useMemo } from 'react';
import { MockStatus } from '../../types';

interface MockStatusIndicatorProps {
  status: {
    value: MockStatus;
    label: string;
  };
}

const MockStatusIndicator: React.FC<MockStatusIndicatorProps> = ({ status }) => {
  const { icon, color } = useMemo(() => {
    switch (status.value) {
      case MockStatus.PREPARING_INPUTS:
        return { icon: <InitiateMockIcon />, color: 'primary' };
      case MockStatus.IN_PROGRESS:
        return { icon: <ClockFilledIcon color="var(--orange-base)" />, color: 'orange' };
      case MockStatus.INPUTS_READY:
        return { icon: <CheckIcon color="var(--pending-fill-color)" />, color: 'yellow' };
      case MockStatus.COMPLETED:
        return { icon: <MockSuccessIcon />, color: 'violet' };
      case MockStatus.FAILED:
        return {
          icon: (
            <div className="rotate-180">
              <InfoSolidSmallIcon fill="var(--red-base)" />
            </div>
          ),
          color: 'red'
        };
      case MockStatus.APPROVED:
        return { icon: <CheckIcon color="var(--green-base)" />, color: 'green' };
      case MockStatus.ALLOCATED:
        return { icon: <MockAllocatedIcon />, color: 'green' };
      default:
        return { icon: null, color: 'primary' };
    }
  }, [status.value]);

  return (
    <Tag
      label={status.label}
      color={color as TagColors}
      variant="transparent"
      startAdornment={icon}
    />
  );
};

export default MockStatusIndicator;
